<template>
  <v-dialog v-model="open" max-width="560">
    <v-card>
      <v-card-title class="globalSearchTitle">Global Search</v-card-title>
      <v-card-text>
        <v-form @submit.prevent="submit">
          <div class="d-flex align-center gap-2">
            <v-text-field
              v-model="query"
              placeholder="Search jobs, people, forms, resources..."
              variant="outlined"
              density="comfortable"
              hide-details
              autofocus
              :loading="loading"
            />
            <v-btn color="primary" type="submit" icon="mdi-magnify" :loading="loading" />
          </div>
        </v-form>
        <p v-if="results.length" class="text-caption mt-3 mb-1">Results</p>
        <v-list v-if="results.length" density="compact">
          <v-list-item
            v-for="item in results"
            :key="resultKey(item)"
            :title="item.title"
            :subtitle="resultSubtitle(item)"
            @click="openResult(item)"
          />
        </v-list>
        <p v-else-if="searched && !loading" class="text-medium-emphasis mt-3">No results found.</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn variant="text" @click="open = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import API from '../../api/myco'

const TYPE_LABELS = {
  user: 'Employee',
  job: 'Job',
  form: 'Form',
  inventory: 'Inventory',
  resource: 'Resource',
  certification: 'Certification',
  maintenance: 'Maintenance',
  submission: 'Submission',
}

export default {
  name: 'GlobalSearchModal',
  props: {
    modelValue: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      query: '',
      results: [],
      searched: false,
      loading: false,
    }
  },
  computed: {
    open: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
        if (!value) {
          this.query = ''
          this.results = []
          this.searched = false
          this.loading = false
        }
      },
    },
  },
  methods: {
    resultKey(item) {
      return item.href || `${item.type}-${item.id}-${item.title}`
    },
    resultSubtitle(item) {
      if (item.subtitle) return item.subtitle
      return TYPE_LABELS[item.type] || item.type
    },
    async submit() {
      const q = this.query.trim()
      if (!q) return
      this.searched = true
      this.loading = true
      try {
        const { data } = await API.search.query(q)
        this.results = Array.isArray(data) ? data : []
      } catch {
        this.results = []
        this.$store.commit('setSnackbar', { type: 'error', message: 'Search failed.' })
      } finally {
        this.loading = false
      }
    },
    openResult(item) {
      this.open = false
      if (item.href) {
        window.open(item.href, '_blank', 'noopener')
        return
      }
      if (item.route) {
        this.$router.push(item.route)
      }
    },
  },
}
</script>

<style scoped>
.globalSearchTitle {
  background: var(--app-theme-color, #2a2971);
  color: #fff;
}
.gap-2 {
  gap: 8px;
}
</style>
